export class CookBookCategoryModel {
  public static IRI = '/api/cook_book_categories';
  public id: number | null ;
  public name: string;
  public type: string;
  public parent: string;
}
